"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.button = exports.value = exports.container = exports.root = void 0;

var react_1 = require("@emotion/react");

exports.root = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
exports.container = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
exports.value = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 24px;\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  margin: 0px 6px;\n  color: var(--gray-800);\n  user-select: none;\n"])));
exports.button = react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: none;\n  border: 1px solid var(--blue-400);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  &[disabled] {\n    border: 1px solid var(--gray-300);\n  }\n  &:hover {\n    background-color: var(--blue-50);\n  }\n"])));